import BlockView from 'views/block/base-block-view';
import LocaleService from 'services/locale-service';
import CustomPageService from 'services/custom-page-service';

export default class CustomPageView extends BlockView {
  load() {
    if(this.model.has('slug')) {
      const { module, activity, page } = CustomPageService.modulePaths();
      if(CustomPageService.hasPageCustomization(this.model.get('slug'), module, activity, page)) {
        CustomPageService.loadPage(this.model.get('slug'), module, activity, page).then(({blocks, locales}) => {
          if(blocks) {
            this.model.set('blocks', blocks);
          }

          if(locales) {
            Object.entries(locales).forEach(([locale, data]) => {
              LocaleService.addResource(
                locale, LocaleService.currentNamespace(),
                LocaleService.currentNamespace().split('.').reduceRight((result, key) => ({ [key]: result }), data)
              );
            })
          }
          this.render();
        });
      }
    }
  }

  render() {
    if(this.model.get('blocks')) {
      this.renderNestedBlocks(`${this.model.get('cid')}-blocks`, this.model.get('blocks'));
    }
    return super.render();
  }

  play() {
    this.readyToGo();
  }
}
